import React, { useContext } from "react";
import Term, { filterTerms } from "../Term";
import { convertDateStringToJp } from "../utility";
import { CategoriesContext } from "./NewsArchive";

export type NewsData = {
  id: number;
  categories: number[];
  title: { rendered: string };
  date: string;
  news_featured_image_urls: {
    full: string;
    large: string;
    medium: string;
    thumbnail: string;
  };
  link: string;
  news_meta: {
    shop: [number];
    shop_post_name: string;
    shop_title: string;
    shop_guid: string;
  };
  slug: string;
};

const News: React.FC<{
  news: NewsData;
}> = ({ news }) => {
  const categories = useContext(CategoriesContext);

  const handleBoxClick = () => {
    window.location.href = news.link;
  };

  return (
    <>
      <div className="news" onClick={() => handleBoxClick()}>
        <div className="news__image-wrapper">
          <img
            className="news__image"
            src={news.news_featured_image_urls?.medium.toString()}
          />
        </div>
        <div className="news__content-wrapper">
          <div className="news__term-date">
            <div className="term">
              {filterTerms(news.categories, categories).map((category) => (
                <Term key={category.id} term={category} />
              ))}
            </div>
            <div className="news__date">{convertDateStringToJp(news.date)}</div>
          </div>
          {news.news_meta.shop_guid && (
            <div className="news__shop shop-link-with-icon">
              <a href={news.news_meta.shop_guid}>{news.news_meta.shop_title}</a>
            </div>
          )}
          <div
            className="news__title"
            dangerouslySetInnerHTML={{ __html: news.title.rendered }}
          ></div>
        </div>
      </div>
    </>
  );
};

export default News;
